export function contains(parentNode, node) {
  if (!globalThis.document) return false;
  if ('contains' in parentNode) {
    return parentNode.contains(node);
  }
  if ('compareDocumentPosition' in parentNode) {
    return parentNode === node || !!(parentNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY);
  }
  do {
    if (node === parentNode) return true;
  } while (node = node.parentNode);
  return false;
}